import React, { Component } from 'react';

class ButtonBorderDarkBlue extends Component {
    render() {
        return (
            <button
                type={this.props.type}
                id={this.props.id}
                onClick={this.props.onClick}
                className={this.props.className + " bg-white rounded border border-darkblue text-darkblue focus:outline-none px-10 py-2"}
                style={this.props.style}
            >
                {this.props.children}
            </button>
        );
    }
}

export default ButtonBorderDarkBlue;